<ng-container *ngIf="clients.length > 0">
	<h3>Execution affidavits</h3>
	<div class="grid grid-cols-2 pt-5 gap-5 h-full">
		<div>
			<app-container
				class="mb-5"
				*ngFor="let client of clients$ | async; trackBy: clientId"
			>
				<div>
					<div class="flex">
						<h4 class="pr-5">{{ client | clientName }}</h4>
						<div class="relative">
							<app-button
								btn="primary"
								(click)="showDropdown(client)"
								[icon]="ICON.ADD"
								size="small"
								[testHook]="testHooks.AddANewStatementButton"
								>Add a new statement</app-button
							>
							<app-dropdown-options
								class="mt-1 relative"
								[itemGroups]="[{ items: StatementOptions }]"
								(mouseleave)="hideDropdown(client)"
								(onSelect)="onSelect($event, client)"
								[show]="dropdownVisible[client.id] ?? false"
								[testHook]="testHooks.DropdownOptions"
							></app-dropdown-options>
						</div>
					</div>
					<div *ngIf="hasExecutions$ | async">
						<app-button
							btn="link"
							size="small"
							[icon]="ICON.ARROW_UP_FROM_BRACKET"
							(onClick)="addImport(client.id, true)"
							[testHook]="testHooks.ImportFromTeranetResultsButton"
							>Import from Teranet results</app-button
						>
					</div>
					<div
						class="grid grid-cols-2 gap-3 mt-5"
						*ngIf="useHtmlDocuments$ | async"
					>
						<div
							class="p-4 bg-gray-50 rounded-lg border-gray-400 cursor-pointer transition-all duration-300 hover:shadow flex gap-3"
							(click)="openDocument(document)"
							*ngFor="let document of documents[client.id]; trackBy: documentId"
							[testHook]="testHooks.OpenDocumentDiv"
						>
							<app-icon classes="text-2xl" icon="file"></app-icon>
							<div>
								{{ document.title }}<br /><small
									>Created: {{ document.createdAt | date }}</small
								><br /><small *ngIf="document.updatedAt"
									>Edited: {{ document.updatedAt | date }}</small
								>
							</div>
						</div>
					</div>
					<div *ngIf="client.affidavits.length" class="mt-5">
						<app-container
							[collapsable]="true"
							title="Statement summaries ({{ client.affidavits.length }})"
							type="light"
						>
							<div
								class="mb-3 mx-2 px-5 py-1 rounded-xl bg-grey-lightest flex items-center justify-between"
								*ngFor="
									let affidavit of client.affidavits;
									trackBy: affidavitId
								"
							>
								<div>
									{{ affidavit.debtor }}, {{ affidavit.plaintiff }}, #{{
										affidavit.executionNumber
									}}, {{ affidavit.amount | centsToDollars }},
									{{ affidavit.costs | centsToDollars }}
								</div>
								<div class="flex">
									<app-button
										btn="tertiary"
										[icon]="ICON.EDIT"
										(onClick)="editStatement(client.id, affidavit)"
										[testHook]="testHooks.EditButton"
									></app-button>
									<app-button
										btn="tertiary"
										class="ml-2"
										[holdable]="true"
										[icon]="ICON.DELETE"
										(onClick)="deleteStatement(affidavit.id)"
										[testHook]="testHooks.DeleteButton"
									></app-button>
								</div>
							</div>
						</app-container>
					</div>
				</div>
			</app-container>
		</div>
	</div>
</ng-container>

<div
	*ngIf="clients.length == 0"
	class="w-full h-full flex flex-col flex-1 justify-center items-center"
>
	<div class="empty-state-image">
		<img
			src="assets/images/empty-states/mortgages.svg"
			alt=""
			class="max-w-500"
		/>
	</div>
	<h3 class="mt-10">Execution affidavits</h3>
	<p class="mt-3">
		No clients have been added to this file yet. Please go to the parties tab
		and add clients to view affidavits.
	</p>
	<div class="mt-5">
		<app-button
			[icon]="ICON.EXTERNAL"
			size="small"
			(click)="goToParties()"
			[testHook]="testHooks.GoToPartiesButton"
			>Go to parties</app-button
		>
	</div>
</div>
